<template>
  <div class="coach-content" v-if="resultData">
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7752eb68b7bb5a9521d40266a0bf5246.png"
      alt=""
    />
    <img class="image" :src="resultData.fatTargetResult.expert_url" alt="" />
    <div class="chat">
      <img
        class="chat-bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d24f1994bee64967875a8ea87014ddef.png"
        alt=""
      />
      <div
        >本方案的设计严格遵照中国居民膳食指南，能保证生长发育需要，改善糖脂代谢紊乱，同时减轻胰岛β细胞的负担。方案适用周期：{{
          durationTime.start
        }}-{{ durationTime.end }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {}
  },
  computed: {
    resultData() {
      return this.$store.state.cnaV2.resultData || null
    },
    durationTime() {
      let info = this.$store.state.cnaV2.resultData
      if (info) {
        let start = info.cnaNewResult.finish_time.replace(/-/g, '/')
        let startDate = new Date(start)
        let endTime = startDate.getTime() + 1000 * 60 * 60 * 24 * 7
        let endDate = new Date(endTime)
        return {
          start:
            startDate.getFullYear() +
            '.' +
            (startDate.getMonth() + 1) +
            '.' +
            startDate.getDate(),
          end:
            endDate.getFullYear() +
            '.' +
            (endDate.getMonth() + 1) +
            '.' +
            endDate.getDate()
        }
      }
      return {
        start: '',
        end: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coach-content {
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  padding: 77px 16px 16px;
  display: flex;
  align-items: center;

  .bg {
    left: 0;
    top: 0;
    z-index: -1;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image {
    width: 76px;
    height: 90px;
    object-fit: contain;
  }

  .chat {
    position: relative;
    z-index: 1;
    width: 272px;
    box-sizing: border-box;
    padding: 9px 10px 9px 22px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #4cbaa7;
    line-height: 16px;

    .chat-bg {
      position: absolute;
      z-index: -1;
      width: 100%;
      height: 100%;
      right: 0;
      top: 0;
    }
  }
}
</style>
